<template>
  <div id="ScreenThree">
    <div class="top-wrap">
      <div class="left-content-wrap">
        <ThreeTopLeftContent :data="firstList"></ThreeTopLeftContent>
      </div>
      <div class="right-content-wrap">
        <ThreeTopRightContent :data="secondList"></ThreeTopRightContent>
      </div>
    </div>
    <div class="bottom-wrap">
      <ThreeBottomContent :data="threeList"></ThreeBottomContent>
    </div>
  </div>
</template>

<script>
import ThreeTopLeftContent from './ThreeTopLeftContent'
import ThreeTopRightContent from './ThreeTopRightContent'
import ThreeBottomContent from './ThreeBottomContent'
export default {
  name: '',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      firstList: {

      },
      secondList: {

      },
      threeList: {}
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {
    data: {
      deep: true,
      handler: function (newValue, oldValue) {
        let { livingRoomVo, operationVO, digitalMarketingVO } = newValue
        this.firstList = livingRoomVo
        this.secondList = operationVO
        this.threeList = digitalMarketingVO
      }
    }
  },
  methods: {

  },
  components: {
    ThreeTopLeftContent,
    ThreeTopRightContent,
    ThreeBottomContent
  }
}
</script>

<style scoped lang="stylus">
.top-wrap
  display: flex
  margin-bottom: 2rem
  .left-content-wrap,.right-content-wrap
    // width 61.5rem
  .left-content-wrap
    margin-right: 1rem
    flex-shrink: 0
    width 66.5rem

#ScreenThree
  >>>
    .item-progress-wrap
      background: rgba(255, 255, 255, 0.05);
      .label-wrap
        color: #fff
        display: flex
        align-items: center
        .name
          font-size: .7rem
          color: rgba(255, 255, 255, 0.8);
          display inline-block
          margin-left 0.13rem
        .kc
          font-size: .9rem
          margin: 0.13rem 0.13rem 0.13rem 0
          margin-left: auto
          display inline-block
    .item-progress-wrap+.item-progress-wrap
      margin-top: 0.6rem
</style>
